module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zard-content",
    attrs: {
      "id": "intro"
    }
  }, [_c('div', {
    staticClass: "left-text col-md-7 text-center"
  }, [_c('printer', {
    attrs: {
      "data": _vm.printData
    },
    on: {
      "end": _vm.onPrinterEnd
    }
  })], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-transition"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPic),
      expression: "showPic"
    }],
    staticClass: "right-pic col-md-5 col-xs-12"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "http://www.wezard.net/20th/images/live/livephoto.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("What a beautiful moment...")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aa6d10d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 104
// module chunks = 0